module.exports = __webpack_public_path__ + "static/media/wgc.459dd81e.png";